import classNames from 'classnames';
import { FC, memo } from 'react';
import Example from '../Example';

interface iFamilyProps {
  name: string;
  value: string;
  price: number | null;
  description?: string;
  active?: boolean;
  onSelect: (family: string) => void;
  dimensions?: number[];
  example?: string;
}

const Family: FC<iFamilyProps> = memo(({ example, value, name, price, description, onSelect, active, dimensions }) => {
  const _handleSelect = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onSelect(value);
  };

  return (
    <div className={classNames('option', active && 'active')} onMouseDown={_handleSelect}>
      <header>
        <span>{name}</span>
        {price ? (
          <span>
            ({price > 0 ? '+' : '-'}£{Math.abs(price).toFixed(2)})
          </span>
        ) : null}
      </header>
      <header>
        <p>{dimensions ? `${Math.round(dimensions[0])}cm` : description}</p>
        {example && <Example content={example} />}
      </header>
    </div>
  );
});

export default Family;
